<template>
  <button
    class="course-class"
    :class="{'course-class--active' : isActive, 'course-class--unreleased' : isUnreleased}"
    v-on="this.$listeners"
  >
    <picture class="course-class__picture">
      <CourseTag
        v-if="courseClass.is_public"
        class="position--top-right"
      >Grátis</CourseTag>

      <img :src="courseClass.thumb" />

      <div
        v-if="courseClass.attended_percent"
        class="course-class__attended"
      >{{ courseClass.attended_percent }}%</div>

      <CourseLoadDuration :duration="courseClass.load_duration" class="position--bottom-right" />
    </picture>

    <div class="course-class__info">
      <span class="course-class__info__name">{{ courseClass.name }}</span>
    </div>
  </button>
</template>

<script>
  import { mapGetters } from 'vuex'
  import CourseTag from '@/components/course/CourseTag'
  import CourseLoadDuration from '@/components/course/CourseLoadDuration'

  export default {
    components: {
      CourseTag,
      CourseLoadDuration,
    },

    props: {
      courseClass: { type: Object, required: true }
    },

    computed: {
      ...mapGetters('course', ['courseModuleClass']),
      ...mapGetters('user', ['hasUserSubscriptionAccess']),

      isActive () {
        return this.courseModuleClass.id == this.courseClass.id
      },

      isUnreleased () {
        return !this.courseClass.is_released
      }
    }
  }
</script>

<style lang="scss" scoped>
  .course-class {
    $p: &;

    display: flex;
    align-items: center;
    padding: 10px;
    background: darken(#fff, 5%);
    border-bottom: 2px solid darken(#fff, 10%);
    border-radius: 10px;

    &__picture {
      flex: 0 0 35%;
      position: relative;
      border-radius: 5px;

      img { max-width: 100%; width: auto; border-radius: 5px }
      
    }

    &__attended {
      position: absolute;
      top: 50%;
      left: 0;
      z-index: 2;
      transform: translate(-50%, -50%);
      width: 2.25rem;
      height: 2.25rem;
      border-radius: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(lighten(#000, 70%), .9);
      background: rgba(#ff8000, .9);
      color: #fff;
      font-size: 0.75rem;
      font-weight: 700;
      box-shadow: 1px 1px 15px rgba(#000, .6);
    }

    &__info {
      padding-left: 15px;
      line-height: 1.1;
      text-align: left;

      &__name { font-size: 0.9375rem; font-weight: 700 }
    }

    &--active {
      background: lighten(#ff8800, 15%);
      border-bottom: 2px solid lighten(#ff8800, 5%);

      #{$p}__info__name { color: #fff }
    }

    &--unreleased {
      #{$p}__picture {
        overflow: hidden;
        img { opacity: .5; filter: blur(4px); }
        
        &:after {
          content: 'Aula nova chegando!';
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          position: absolute;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
          background: rgba(#ff8000, .4);
          font-weight: 700;
          font-size: 0.9375rem;
          line-height: 0.9375rem;
          border-radius: 5px;
        }
      }

      #{$p}__info__name { color: lighten(#000, 60%) }
    }
  }
</style>